module.exports = __webpack_public_path__ + "img/HZ-S4019.43e3e3c7.jpg";